import InterRegularText from './InterRegularText';

export default InterRegularText;
